export default "__VITE_ASSET__BGmE3kbV__"